// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","selectedFare":"selectedFare-2aDz_","compareFares":"compareFares-1lTyF","slider_withoutImages":"slider_withoutImages-X9350"};